import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

export const Card = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={cn(
        'rounded-sm px-5 py-6 shadow-[0px_1px_7px_0px_rgba(0,0,0,0.15)]',
        className,
      )}
    >
      {children}
    </div>
  )
}
